import { takeLatest, call, put } from 'redux-saga/effects'
import getCourses from 'api/administration/certificates/GetCourses'
import * as fromActions from 'store/actions/certificates.action'

async function getList(certificateType: number, certificateId?: number) {
  return await getCourses(certificateType, certificateId)
}

function* certificateCourseListEffectSaga(action: any) {
  try {
    const { certificateType, certificateId } = action.payload
    const { data } = yield call(getList, certificateType, certificateId)
    yield put(fromActions.Actions.certificateCoursesAdministrationListSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* certificateCourseListWatcherSaga() {
  yield takeLatest(fromActions.CERTIFICATE_COURSES_LIST, certificateCourseListEffectSaga)
}